module.exports = __webpack_public_path__ + "img/bela.f77c5c6d.svg";